/* eslint-disable */
export default {
  download: 'Télécharger',
  play: 'Lire',
  pause: 'Pause',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
